<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import PageHeader from "../components/PageHeader.svelte";
    import A from "../lib/Router/A.svelte";
    import {copyObject, formatDate, getDate, setFocusTo, sort} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";
    import {APP_PATH} from "../lib/constants";

    let sampleTypes = [];
    let samplePackages = [];
    let samplingFrom = [];
    let samplingMethod = [];

    const pageHeaderControls = [
        {id: 'save', name: 'ΕΝΗΜΕΡΩΣΗ', tip: 'ενημέρωση ρυθμίσεων', class: 'hidden-xs'},
        {
            id: 'save',
            name: '',
            tip: 'ενημέρωση ρυθμίσεων',
            icon: 'save',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
    ];

    const initialize = () => {

        sampleTypes = $app.sample_types.join("\n");
        samplePackages = $app.sample_packages.join("\n");
        samplingFrom = $app.sampling_from.join("\n");
        samplingMethod = $app.sampling_method.join("\n");
    }


    const save = () => {

        const onSuccess = result => {
            $app.sample_types = result.sample_types;
            $app.sample_packages = result.sample_packages;
            $app.sampling_from = result.sampling_from;
            $app.sampling_method = result.sampling_method;
            Notifier.showMessage("Οι ρυθμίσεις ενημερώθηκαν");
        }

        const onFailure = err => {
        };

        let data = {
            sample_types: getArrayValues(sampleTypes),
            sample_packages: getArrayValues(samplePackages),
            sampling_from: getArrayValues(samplingFrom),
            sampling_method: getArrayValues(samplingMethod),
        }

        R.handle(R.app.editSettings, data, onSuccess, onFailure, LOADER.POPUP);
    }


    const getArrayValues = (str) => {
        let arr = str.split("\n");
        let values = [];
        arr.map(item => {
            item = item.trim();
            if (item) {
                values.push(item);
            }
        });
        return values.sort();
    }


    initialize();

</script>
<PageHeader title="Ρυθμίσεις" controls={ pageHeaderControls } on:save={ save }/>
<div class="panel-simple panel-pad mb-4">
    <div class="row d-flex">
        <div class="col-xl-2 col-sm-3 col-6">
            <div class="form-group">
                <label>Είδη δειγμάτων</label>
                <textarea class="form-control" rows="20" bind:value="{ sampleTypes }"></textarea>
            </div>
        </div>
        <div class="col-xl-2 col-sm-3 col-6">
            <div class="form-group">
                <label>Συσκευασίες δειγμάτων</label>
                <textarea class="form-control" rows="20" bind:value="{ samplePackages }"></textarea>
            </div>
        </div>
        <div class="col-xl-2 col-sm-3 col-6">
            <div class="form-group">
                <label>Δειγματοληψία από</label>
                <textarea class="form-control" rows="20" bind:value="{ samplingFrom }"></textarea>
            </div>
        </div>
        <div class="col-xl-2 col-sm-3 col-6">
            <div class="form-group">
                <label>Μέθοδος δειγματοληψίας</label>
                <textarea class="form-control" rows="20" bind:value="{ samplingMethod }"></textarea>
            </div>
        </div>
    </div>
</div>